module.exports = __webpack_public_path__ + "static/media/nginx-logo.ff673a8f.png";